import React from 'react';

const Bottom2Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="276" 
      height="125" 
      viewBox="0 0 276 125" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        fill-rule="evenodd" 
        clip-rule="evenodd" 
        d="M164.625 327.75C255.131 327.75 328.5 254.381 328.5 163.875C328.5 73.3693 255.131 0 164.625 0C74.1193 0 0.75 73.3693 0.75 163.875C0.75 254.381 74.1193 327.75 164.625 327.75ZM164.623 264.247C220.058 264.247 264.997 219.308 264.997 163.873C264.997 108.438 220.058 63.4996 164.623 63.4996C109.189 63.4996 64.25 108.438 64.25 163.873C64.25 219.308 109.189 264.247 164.623 264.247Z" 
        fill="white"
      />
    </svg>
  );
};

export default Bottom2Shape;
